import { Vue, Component, Prop } from 'vue-property-decorator'
import PriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot.vue'
import SampleDetailedIcon from '@/assets/images/svg/sample-detailed-icon.vue'

@Component({
    components: {
        PriorityDot,
        SampleDetailedIcon
    }
})
export default class GrossingTouchSamplePendingCard extends Vue {
    @Prop(Object) readonly sampleInfo!: object
}
